module.exports = "https://p.cds.unp.clasificados.pe/logo-mastercard.3236c74a8aa9b12b794409775ab7ca97.svg";